import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#126A73', dark: '#0B5059', contrastText: '#FFFFFF' },
    secondary: { main: '#607680' },
    success: { main: '#267468' },
    warning: { main: '#B16B16' },
    info: { main: '#386B89' },
    error: { main: '#B74949' },
    text: { primary: '#183743', secondary: '#607680' },
    background: { default: '#F2F7FA', paper: '#FFFFFF' },
    divider: '#DCE7EA',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Hiragino Kaku Gothic ProN", "Yu Gothic", -apple-system, BlinkMacSystemFont, sans-serif',
    h1: { fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.4, letterSpacing: '-0.04em' },
    h2: { fontSize: '1.875rem', fontWeight: 700, lineHeight: 1.45, letterSpacing: '-0.035em' },
    h3: { fontSize: '1.625rem', fontWeight: 700, lineHeight: 1.5 },
    h4: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.5 },
    h5: { fontSize: '1.25rem', fontWeight: 700, lineHeight: 1.5 },
    h6: { fontSize: '1rem', fontWeight: 700, lineHeight: 1.6 },
    body1: { fontSize: '0.9375rem', lineHeight: 1.85 },
    body2: { fontSize: '0.8125rem', lineHeight: 1.8 },
    button: { textTransform: 'none', fontWeight: 700, letterSpacing: '0.015em' },
  },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: '#F2F7FA' } } },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, minHeight: 42, padding: '10px 20px' },
        sizeSmall: { minHeight: 36, padding: '6px 12px' },
        sizeLarge: { minHeight: 52, padding: '13px 24px' },
        outlined: { borderColor: '#C4D8DC' },
      },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }, rounded: { borderRadius: 20 } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: '#FFFFFF', borderRadius: 10 },
        notchedOutline: { borderColor: '#CEDDE2' },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 12, alignItems: 'center', fontSize: '0.8125rem' },
        standardSuccess: { color: '#245E54', backgroundColor: '#E1F1EF' },
        standardInfo: { color: '#355D72', backgroundColor: '#EAF2F7' },
        standardWarning: { color: '#875213', backgroundColor: '#FFF3DF' },
        action: { paddingTop: 0 },
      },
    },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 24 } } },
    MuiDialogTitle: { styleOverrides: { root: { padding: '28px 28px 16px', fontWeight: 700 } } },
    MuiDialogContent: { styleOverrides: { root: { padding: '12px 28px 24px' } } },
    MuiDialogActions: { styleOverrides: { root: { padding: '12px 28px 24px', gap: 8 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600, borderRadius: 8 } } },
    MuiTableCell: { styleOverrides: { root: { borderColor: '#E5EDF0' }, head: { color: '#607680', fontWeight: 700, backgroundColor: '#F8FBFC' } } },
    MuiLink: { defaultProps: { underline: 'hover' } },
  },
});

export default theme;
